import VState from 'signal/v-state'

const sidebarOpenState = new VState(false)

export default sidebarOpenState